import { render, staticRenderFns } from "./teacher-detail.vue?vue&type=template&id=2c210799&scoped=true&"
import script from "./teacher-detail.vue?vue&type=script&lang=js&"
export * from "./teacher-detail.vue?vue&type=script&lang=js&"
import style0 from "./teacher-detail.vue?vue&type=style&index=0&id=2c210799&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c210799",
  null
  
)

component.options.__file = "teacher-detail.vue"
export default component.exports